/* eslint-disable */
import TermPage from '../../../components/pages/termPage'

const Legal = ({ className }) => {
   return (
      <TermPage className={className} currentKey="notices" />
   )
}
export default Legal